import { DataSource } from "../../Data/DataSource";
import { PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyObject, PropertyString } from "../../RadObject";
import { ClientAwareCategoryAttribute } from "../../Server/DotNet/SeriouslyRAD.Framework/ClientAwareCategoryAttribute";
import { ClientAwareDisplayNameAttribute } from "../../Server/DotNet/SeriouslyRAD.Framework/ClientAwareDisplayNameAttribute";
import { WebApiClientService } from "../../Server/WebApiClientService";
import { ServiceManager } from "../../ServiceManager";
import { CheckBoxList, CheckBoxListPropertyValues, ICheckBoxList } from "./CheckBoxList";
import { NAMESPACE } from "./_Namespace";

export type CheckBoxListApiMethodPropertyValues =
    CheckBoxListPropertyValues
    & {
        api: string;
        data: any;
        method: string;
    };

export type CheckBoxListApiMethodProperties = {
    [name in keyof CheckBoxListApiMethodPropertyValues]: Property<CheckBoxListApiMethodPropertyValues[name]>
};

export interface ICheckBoxListApiMethod extends ICheckBoxList, CheckBoxListApiMethodProperties
{
}

export class CheckBoxListApiMethod extends CheckBoxList implements ICheckBoxListApiMethod
{
    // #region Static

    public static override classNamespace = NAMESPACE + "CheckBoxListApiMethod";
    public static override className = "CheckBoxListApiMethod";

    // #endregion

    // #region Instance

    // #region Properties

    public api!: PropertyString;
    public data!: PropertyObject;
    public method!: PropertyString;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<CheckBoxListApiMethodPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Public Methods

    public async loadDataAsync()
    {
        const
            api = this.api.get(),
            method = this.method.get(),
            data = this.data.get(),
            listData =
                api && method
                    ? await ServiceManager.getRequired(WebApiClientService)
                        .createApiMethodRequest(api, method, data)
                        .executeAsync()
                    : [];

        this.listDataSource.set(new DataSource({ data: listData }));

        this.triggerHandler("listDataSourceChanged");
    }

    // #endregion

    // #region Protected Methods

    protected _dataServiceDataChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }
    protected _dataServiceIdChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }
    protected _dataServiceMethodChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: CheckBoxListApiMethodPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.api =
            new PropertyString(
                this,
                propertyValues.api,
                this._dataServiceIdChanged,
                undefined,
                [
                    new ClientAwareCategoryAttribute({ category: "Data" }),
                    new ClientAwareDisplayNameAttribute({ displayName: "Api" }),
                ]
            );

        this.data =
            new PropertyObject(
                this,
                propertyValues.data,
                this._dataServiceDataChanged,
                undefined,
                [
                    new ClientAwareCategoryAttribute({ category: "Data" }),
                    new ClientAwareDisplayNameAttribute({ displayName: "Data" }),
                ]
            );

        this.method =
            new PropertyString(
                this,
                propertyValues.method,
                this._dataServiceMethodChanged,
                undefined,
                [
                    new ClientAwareCategoryAttribute({ category: "Data" }),
                    new ClientAwareDisplayNameAttribute({ displayName: "Method" }),
                ]
            );
    }

    // #endregion

    // #endregion
}

